import axios from "axios";
import Config from "../config.json";
import { getStoredSuccessfulLoginData } from "./auth";

const localApiBaseUrl = "/api";

const apiBaseUrl =
  process.env.REACT_APP_BASE_URL ||
  (process.env.NODE_ENV === "development" ? localApiBaseUrl : Config.url);

const authorizationHeaders = () => {
  const token = getStoredSuccessfulLoginData()?.accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const postAuthorized = async (path, data = {}) => {
  const response = await axios.post(`${apiBaseUrl}${path}`, data, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...authorizationHeaders(),
    },
  });

  if (response.data?.ok === false) {
    throw new Error(
      response.data.message || "انجام درخواست با خطا مواجه شد.",
    );
  }

  return response.data?.data;
};

export const fetchWorkshopRegistration = registrationId =>
  postAuthorized(`/workshops/register/show/${registrationId}`, {
    id: registrationId,
  });

export const fetchWorkshopPaymentLink = registrationId =>
  postAuthorized(`/workshops/register/pay-link/${registrationId}`, {
    id: registrationId,
  });

export const cancelWorkshopRegistration = registrationId =>
  postAuthorized(`/workshops/register/cancel/${registrationId}`, {
    id: registrationId,
  });

export const fetchMyWorkshopRegistrations = async (page = 1) => {
  const response = await axios.get(`${apiBaseUrl}/workshops/register/mine`, {
    headers: authorizationHeaders(),
    params: {
      current_page: page,
      page_size: 12,
    },
  });
  const payload = response.data?.data || {};
  return {
    items: payload.data || [],
    meta: payload.meta || { current_page: page, total: 0, per_page: 12 },
  };
};

export const downloadCertificate = async certificate => {
  let downloadUrl = certificate.download_url;
  if (process.env.NODE_ENV === "development") {
    const parsedUrl = new URL(downloadUrl, window.location.origin);
    downloadUrl = `${window.location.origin}${parsedUrl.pathname}${parsedUrl.search}`;
  }

  const certificateTab = window.open(downloadUrl, "_blank");
  if (!certificateTab) {
    throw new Error("مرورگر اجازه باز کردن تب جدید را نداد. لطفاً نمایش پاپ‌آپ را برای این سایت فعال کنید.");
  }
  certificateTab.opener = null;
};

export const verifyCertificate = async token => {
  const response = await axios.get(
    `${apiBaseUrl}/workshops/certificates/verify/${encodeURIComponent(token)}`,
  );
  return response.data?.data;
};
